// =============================================================================
// App — route definitions. Sites table is the landing page (R16).
// Intelligence page merges Control Tower + Jeopardy into one view.
// =============================================================================
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { SitesPage } from './pages/Sites'
import { DashboardPage } from './pages/Dashboard'
import { IntelligencePage } from './pages/Intelligence'
import { ActivityPage } from './pages/Activity'
import { ReportPage } from './pages/Report'
import { AskPortalPage } from './pages/AskPortal'
import { useAsync } from './hooks/useAsync'
import { api } from './lib/api'
import { Skeleton } from './components/ui'
import type { Meta } from './lib/types'

export function App() {
  const { data: meta, loading, error } = useAsync<Meta>(() => api.meta(), [])

  if (loading) return <div className="flex h-screen items-center justify-center"><Skeleton className="h-8 w-48" /></div>
  if (error || !meta) return <div className="flex h-screen items-center justify-center text-rag-red">{error || 'Failed to load'}</div>

  return (
    <Routes>
      <Route element={<Layout personas={meta.personas} />}>
        <Route index element={<SitesPage meta={meta} />} />
        <Route path="dashboard" element={<DashboardPage meta={meta} />} />
        <Route path="intelligence" element={<IntelligencePage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="report" element={<ReportPage />} />
        <Route path="chat" element={<AskPortalPage />} />
        {/* Legacy routes redirect to merged page */}
        <Route path="plan" element={<Navigate to="/dashboard" replace />} />
        <Route path="control-tower" element={<IntelligencePage />} />
        <Route path="jeopardy" element={<IntelligencePage />} />
      </Route>
    </Routes>
  )
}
